import { BaseModel } from '../base.model';
import { JsonProperty, ProblemModel, SmartSavers } from '..';

class ProblemProgressModel extends BaseModel {

  id: number;
  answer: string;
  isCorrect: number;
  time: number;
  isPersistence: number;
  smartSaverUsed: SmartSavers;
  reviewFlagged: number;

  @JsonProperty({ clazz: ProblemModel })
  problem: ProblemModel = undefined;

}

export { ProblemProgressModel };
